/**
 * Permissões RBAC do submódulo Projetos Executivos (auditoria RBAC 2026-07-02).
 *
 * Modelo em duas camadas, mesmo padrão das páginas legadas:
 * - `projetos_executivos:view` é o GUARDA-CHUVA: concede o submódulo inteiro.
 * - Cada página tem sua permissão própria `pe_<slug>:view`, concedível
 *   individualmente na matriz do RBAC (categoria "Projetos").
 *
 * Todos os gates usam requireAny(guarda-chuva OU página) — quem tem o
 * guarda-chuva vê tudo; quem tem só algumas páginas vê só essas.
 * Catálogo canônico no backend: permissoes/catalogo.py (+ seed migration 0009).
 */

export const PE_UMBRELLA = "projetos_executivos:view";

// slug da rota -> código da permissão da página
export const PE_PERMISSAO_POR_SLUG = {
  "visao-geral": "pe_visao_geral:view",
  "fila-gargalos": "pe_fila_gargalos:view",
  "fluxo-lead-time": "pe_fluxo_lead_time:view",
  "retrabalho-aprovacao": "pe_retrabalho_aprovacao:view",
  interferencias: "pe_interferencias:view",
  "equipe-produtividade": "pe_equipe_produtividade:view",
  "vazao-mensal": "pe_vazao_mensal:view",
  "qualidade-dificuldades": "pe_qualidade_dificuldades:view",
  "sem-acabamento": "pe_sem_acabamento:view",
  "sem-medicao": "pe_sem_medicao:view",
  "aguardando-aprovacao": "pe_aguardando_aprovacao:view",
  "ambientes-por-projetista": "pe_ambientes_por_projetista:view",
  detalhamento: "pe_detalhamento:view",
  "versao-retrabalho": "pe_versao_retrabalho:view",
  "mensal-por-envio": "pe_mensal_por_envio:view",
  "finalizacao-por-data": "pe_finalizacao_por_data:view",
  ambientes: "pe_ambientes:view",
};

// Gate da rota /projetos-executivos/*: entra quem tem o guarda-chuva OU
// qualquer página individual (a página específica é validada por slug dentro
// do submódulo).
export const PE_ROUTE_ANY = [PE_UMBRELLA, ...Object.values(PE_PERMISSAO_POR_SLUG)];

// Gate por item de sidebar/página: guarda-chuva OU a página específica.
export const peRequireAny = (slug) => [PE_UMBRELLA, PE_PERMISSAO_POR_SLUG[slug]];
